<div class="modal-header">
    <h6 class="modal-title" translate>TITLE.TITLE_FILTERS</h6>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="form-row align-items-center">
        <div
            class="form-group col-6"
            [hidden]="!CFE(_FilterTypes.CallDescription)"
        >
            <label translate>LBL.DESCR</label>
            <ng-select
                [items]="lstCallDescriptions"
                bindLabel="Description"
                [multiple]="true"
                [closeOnSelect]="false"
                bindValue="Id"
                placeholder="{{'PH.PH_DESCR' | translate}}"
                name="CallDescriptionsId"
                [(ngModel)]="RequestModel.CallDescriptions"
                #cmbCallDescriptions="ngModel"
                [virtualScroll]="true"
            >
                <!-- <ng-template ng-header-tmp>
                            <div>
                              <button class="btn btn-outline-secondary" type="button"
                                      (click)="selectAll(cmbCallDescriptions,'CallDesc')">Select All</button>
                            </div>
                        </ng-template> -->
            </ng-select>
        </div>

        <div class="form-group col-6" [hidden]="!CFE(_FilterTypes.Location)">
            <label translate>LBL.LOCATION</label>
            <ng-select
                [items]="lstLocations"
                bindLabel="Description"
                [multiple]="true"
                [closeOnSelect]="false"
                bindValue="Id"
                placeholder="{{'PH.PH_LOCATION' | translate}}"
                name="LocationId"
                [(ngModel)]="RequestModel.Locations"
                #cmbLocations="ngModel"
                [virtualScroll]="true"
            >
                <!-- <ng-template ng-header-tmp>
                            <div>
                              <button class="btn btn-outline-secondary" type="button"
                                      (click)="selectAll(cmbLocations,'Location')">Select All</button>
                            </div>
                        </ng-template> -->
            </ng-select>
        </div>

        <div
            class="form-group col-6"
            [hidden]="!CFE(_FilterTypes.CallCategory)"
        >
            <label translate>LBL.CATEGORY</label>
            <ng-select
                [items]="lstCallCategories"
                bindLabel="Description"
                [multiple]="true"
                [closeOnSelect]="false"
                bindValue="Id"
                placeholder="{{'PH.PH_CATEGORY' | translate}}"
                name="CategoryId"
                [(ngModel)]="RequestModel.CallCategories"
                #cmbCallCategories="ngModel"
                [virtualScroll]="true"
            >
                <!-- <ng-template ng-header-tmp>
                            <div>
                              <button class="btn btn-outline-secondary" type="button"
                                      (click)="selectAll(cmbCallCategories,'CallCategory')">Select All</button>
                            </div>
                        </ng-template> -->
            </ng-select>
        </div>

        <div class="form-group col-6" [hidden]="!CFE(_FilterTypes.Dept)">
            <label translate>LBL.DEPARTMENT</label>
            <ng-select
                [items]="lstDepartments"
                bindLabel="Name"
                [multiple]="true"
                [closeOnSelect]="false"
                bindValue="Id"
                placeholder="{{'PH.PH_DEPARTMENT' | translate}}"
                name="DepartmentId"
                [(ngModel)]="RequestModel.Departments"
                #cmbDept="ngModel"
                [virtualScroll]="true"
            >
                <!-- <ng-template ng-header-tmp>
                            <div>
                              <button class="btn btn-outline-secondary" type="button"
                                      (click)="selectAll(cmbDept,'Department')" translate>BTN.BTN_SELECT_ALL</button>
                            </div>
                        </ng-template> -->
            </ng-select>
        </div>

        <div class="form-group col-6" [hidden]="!CFE(_FilterTypes.AssignedTo)">
            <label translate>LBL.ASSIGN_TO</label>
            <ng-select
                [items]="lstStaff"
                bindLabel="Name"
                [multiple]="true"
                [closeOnSelect]="false"
                bindValue="Id"
                placeholder="{{'PH.PH_ASSIGN_TO' | translate}}"
                name="AssignedTo"
                [(ngModel)]="RequestModel.AssignedTo"
                #cmbAssignedTo="ngModel"
                [virtualScroll]="true"
            >
                <!-- <ng-template ng-header-tmp>
                            <div>
                              <button class="btn btn-outline-secondary" type="button"
                                      (click)="selectAll(cmbAssignedTo,'Assign')">Select All</button>
                            </div>
                        </ng-template> -->
            </ng-select>
        </div>

        <div class="form-group col-6" [hidden]="!CFE(_FilterTypes.Pax)">
            <label translate>LBL.PAX</label>
            <ng-select
                [items]="lastPax"
                bindLabel="Name"
                [multiple]="false"
                [closeOnSelect]="false"
                bindValue="Id"
                placeholder="{{'LBL.PAX' | translate}}"
                name="paxInvolved"
                [(ngModel)]="RequestModel.PAX"
                #cmbPax="ngModel"
                [virtualScroll]="true"
            >
            </ng-select>
        </div>

        <div
            class="form-group col-6"
            [hidden]="!CFE(_FilterTypes.TaggedStaffIds)"
        >
            <label translate>LBL.TAGGED_STAFF</label>
            <ng-select
                [items]="lstTaggedStaffs"
                bindLabel="Name"
                [multiple]="true"
                [closeOnSelect]="false"
                bindValue="Id"
                placeholder="{{'PH.PH_TAGGED_STAFF' | translate}}"
                name="TaggedStaffIds"
                [(ngModel)]="RequestModel.TaggedStaffIds"
                #cmbTaggedStaffIds="ngModel"
                [virtualScroll]="true"
            >
            </ng-select>
        </div>

        <div class="form-group col-6" [hidden]="!CFE(_FilterTypes.ReportedBy)">
            <label translate>LBL.REPORTED_BY</label>
            <ng-select
                [items]="lstStaff"
                bindLabel="Name"
                [multiple]="true"
                [closeOnSelect]="false"
                bindValue="Id"
                placeholder="{{'PH.PH_REPORTED_BY' | translate}}"
                name="RequestedBy"
                [(ngModel)]="RequestModel.RequestedBy"
                #cmbRequestBy="ngModel"
                [virtualScroll]="true"
            >
                <!-- <ng-template ng-header-tmp>
                            <div>
                              <button class="btn btn-outline-secondary" type="button"
                                      (click)="selectAll(cmbRequestBy,'Reported')">Select All</button>
                            </div>
                        </ng-template> -->
            </ng-select>
        </div>

        <div class="form-group col-6" [hidden]="!CFE(_FilterTypes.LoggedBy)">
            <label translate>LBL.LOGGED_BY</label>
            <ng-select
                [items]="lstStaff"
                bindLabel="Name"
                [multiple]="true"
                [closeOnSelect]="false"
                bindValue="Id"
                placeholder="{{'PH.PH_LOGGED_BY' | translate}}"
                name="LoggedBy"
                [(ngModel)]="RequestModel.LoggedBy"
                #cmbLoggedBy="ngModel"
                [virtualScroll]="true"
            >
                <!-- <ng-template ng-header-tmp>
                            <div>
                              <button class="btn btn-outline-secondary" type="button"
                                      (click)="selectAll(cmbLoggedBy,'Logged')">Select All</button>
                            </div>
                        </ng-template> -->
            </ng-select>
        </div>

        <div class="form-group col-6" [hidden]="!CFE(_FilterTypes.Sections)">
            <label translate>LBL.SECTION</label>
            <ng-select
                [items]="lstSections"
                bindLabel="Name"
                [multiple]="true"
                [closeOnSelect]="false"
                bindValue="Id"
                placeholder="{{'PH.PH_SECTION' | translate}}"
                name="Sections"
                [(ngModel)]="RequestModel.Sections"
                #cmbSections="ngModel"
                [virtualScroll]="true"
            >
                <!-- <ng-template ng-header-tmp>
                            <div>
                              <button class="btn btn-outline-secondary" type="button"
                                      (click)="selectAll(cmbSections,'Section')">Select All</button>
                            </div>
                        </ng-template> -->
            </ng-select>
        </div>

        <div class="form-group col-6" [hidden]="!CFE(_FilterTypes.Vip)">
            <label translate>LBL.VIP</label>
            <ng-select
                [items]="lstVIP"
                bindLabel="Description"
                [multiple]="true"
                [closeOnSelect]="false"
                bindValue="Code"
                placeholder="{{'PH.PH_VIP' | translate}}"
                name="VIP"
                [(ngModel)]="RequestModel.VIPCodes"
                #cmbVIPCodes="ngModel"
                [virtualScroll]="true"
            >
                <ng-template ng-header-tmp>
                    <div>
                        <button
                            class="btn btn-outline-secondary"
                            type="button"
                            (click)="selectAll(cmbVIPCodes,'VIP')"
                            translate
                        >
                            BTN.BTN_SELECT_ALL
                        </button>
                    </div>
                </ng-template>
            </ng-select>
        </div>

        <div class="form-group col-6" [hidden]="!CFE(_FilterTypes.Priority)">
            <label translate>LBL.LBL_PRIORITY</label>
            <ng-select
                [items]="lstPriority"
                bindLabel="Name"
                bindValue="Id"
                placeholder="{{'PH.PH_PRIORITY' | translate}}"
                name="Priority"
                [(ngModel)]="RequestModel.Priority"
                #cmbPriority="ngModel"
                [virtualScroll]="true"
            >
            </ng-select>
        </div>
        <div class="form-group col-6" [hidden]="!CFE(_FilterTypes.RoomStatus)">
            <label translate>LBL.ROOM_STATUS</label>
            <select class="form-control" [(ngModel)]="RequestModel.RoomStatus">
                <option value="" translate>
                    ENTITIES.ENTITIES_ROOM_STATUS
                </option>
                <option value="V" translate>ENTITIES.ENTITIES_VACANT</option>
                <option value="O" translate>ENTITIES.ENTITIES_OCCUPIED</option>
                <option value="A" translate>
                    ENTITIES.ENTITIES_VACANT_OCCUPIED
                </option>
            </select>
        </div>
        <div
            class="form-group col-6"
            [hidden]="!CFE(_FilterTypes.EndPattern)"
            *ngIf="RequestModel.lstEndPattern"
        >
            <label translate>LBL.END_PATTERN</label>
            <div class="form-check">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="EndPattern_1"
                    [checked]="RequestModel.lstEndPattern.indexOf(1)>=0"
                    (change)="setEndPattern(1, $event.target.checked)"
                />
                <span class="form-check-label" for="EndPattern_1" translate>
                    LBL.END_DATE_BASED
                </span>
            </div>
            <div class="form-check">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="EndPattern_2"
                    [checked]="RequestModel.lstEndPattern.indexOf(2)>=0"
                    (change)="setEndPattern(2, $event.target.checked)"
                />
                <span class="form-check-label" for="EndPattern_2" translate>
                    LBL.OCCURRENCE_BASED
                </span>
            </div>
            <div class="form-check">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="EndPattern_3"
                    [checked]="RequestModel.lstEndPattern.indexOf(3)>=0"
                    (change)="setEndPattern(3, $event.target.checked)"
                />
                <span class="form-check-label" for="EndPattern_3" translate>
                    LBL.NO_END_DATE
                </span>
            </div>
        </div>
        <div
            class="form-group col-6"
            [hidden]="!CFE(_FilterTypes.NextOccurrence)"
        >
            <label translate>LBL.NEXT_OCCURRENCE</label>
            <div class="row align-items-center no-gutters">
                <div class="col-4 mr-1">
                    <span translate>LBL.DATE_RANGE_START</span>
                </div>
                <div class="col-auto">
                    <div class="input-group">
                        <p-calendar
                            name="DateRangeStart"
                            [(ngModel)]="RequestModel.DateRangeStart"
                            placeholder="{{'PH.PH_YYYY_MM_DD' | translate}}"
                            dateFormat="yy/mm/dd"
                            hideOnDateTimeSelect="true"
                            showTime="true"
                            hourFormat="12"
                            showIcon="true"
                            styleClass=""
                        ></p-calendar>
                    </div>
                </div>
            </div>
            <div class="row align-items-center no-gutters mt-2">
                <div class="col-4 mr-1">
                    <span translate>LBL.DATE_RANGE_END</span>
                </div>
                <div class="col-auto">
                    <div class="input-group">
                        <p-calendar
                            name="DateRangeEnd"
                            [(ngModel)]="RequestModel.DateRangeEnd"
                            placeholder="{{'PH.PH_YYYY_MM_DD' | translate}}"
                            dateFormat="yy/mm/dd"
                            hideOnDateTimeSelect="true"
                            showTime="true"
                            hourFormat="12"
                            showIcon="true"
                            styleClass=""
                        ></p-calendar>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="form-group col-6 form-inline"
            [hidden]="!CheckActiveLicence_Module(RequestModel.Properties[0], _ModuleLicenceCodes.TritonGlitch)  || !CFE(_FilterTypes.HasGlitch)"
        >
            <label translate>LBL.GLITCH</label>
            <div class="form-check ml-4">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="HasGlitch"
                    [(ngModel)]="RequestModel.HasGlitchRegistered"
                />
                <!--<span class="form-check-label" for="HasGlitch" translate>
                LBL.GLITCH
            </span>-->
            </div>
        </div>

        <div
            class="form-group col-6"
            [hidden]="!CFE(_FilterTypes.GlitchCategory)"
        >
            <label translate>LBL.CATEGORY</label>
            <ng-select
                [items]="lstGlitchCategories"
                bindLabel="Description"
                [multiple]="true"
                [closeOnSelect]="false"
                bindValue="Id"
                placeholder="{{'PH.PH_CATEGORY' | translate}}"
                name="CategoryId"
                [(ngModel)]="RequestModel.GlitchCategories"
                #cmbGlitchCategories="ngModel"
                [virtualScroll]="true"
            >
                <!-- <ng-template ng-header-tmp>
                            <div>
                              <button class="btn btn-outline-secondary" type="button"
                                      (click)="selectAll(cmbGlitchCategories,'GlitchCategory')">Select All</button>
                            </div>
                        </ng-template> -->
            </ng-select>
        </div>

        <div
            class="form-group col-6"
            [hidden]="!CFE(_FilterTypes.GlitchDescription)"
        >
            <label translate>LBL.DESCR</label>
            <ng-select
                [items]="lstGlitchDescriptions"
                bindLabel="Description"
                [multiple]="true"
                [closeOnSelect]="false"
                bindValue="Id"
                placeholder="{{'PH.PH_DESCR' | translate}}"
                name="GlitchDescriptionsId"
                [(ngModel)]="RequestModel.GlitchDescriptions"
                #cmbGlitchDescriptions="ngModel"
                [virtualScroll]="true"
            >
                <!-- <ng-template ng-header-tmp>
                            <div>
                              <button class="btn btn-outline-secondary" type="button"
                                      (click)="selectAll(cmbGlitchDescriptions,'GlitchDesc')">Select All</button>
                            </div>
                        </ng-template> -->
            </ng-select>
        </div>

        <div class="form-group col-6" [hidden]="!CFE(_FilterTypes.GlitchStaff)">
            <label translate>LBL.GLITCHSTAFF</label>
            <ng-select
                [items]="lstGlitchStaffs"
                bindLabel="Name"
                [multiple]="true"
                [closeOnSelect]="false"
                bindValue="Id"
                placeholder="{{'PH.PH_STAFF' | translate}}"
                name="GlitchStaffId"
                [(ngModel)]="RequestModel.GlitchStaffs"
                #cmbGlitchStaffs="ngModel"
                [virtualScroll]="true"
            >
                <!-- <ng-template ng-header-tmp>
                            <div>
                              <button class="btn btn-outline-secondary" type="button"
                                      (click)="selectAll(cmbGlitchStaffs,'GlitchStaff')">Select All</button>
                            </div>
                        </ng-template> -->
            </ng-select>
        </div>

        <div
            class="form-group col-6"
            [hidden]="!CFE(_FilterTypes.RegisteredBy)"
        >
            <label translate>LBL.LOGGED_BY</label>
            <ng-select
                [items]="lstLoggedByStaffs"
                bindLabel="Name"
                [multiple]="true"
                [closeOnSelect]="false"
                bindValue="Id"
                placeholder="{{'PH.PH_STAFF' | translate}}"
                name="LoggedByStaffId"
                [(ngModel)]="RequestModel.RegisteredBy"
                #cmbRegisteredByStaffs="ngModel"
                [virtualScroll]="true"
            >
            </ng-select>
        </div>
        <div class="form-group col-6"
        [hidden]="!CFE(_FilterTypes.LoggedDate)">
       <label translate>LBL.LBL_LOG_DATE</label>
       <ng-select [items]="lstloggedDate"
                  bindLabel="Name"
                  [multiple]="false"
                  [closeOnSelect]="true"
                  bindValue="Id"
                  placeholder="{{'PH.PH_LOG_DATE' | translate}}"
                  name="LoggedDateRange"
                  [(ngModel)]="RequestModel.LoggedDateRange"
                  #cmbLoggedDate="ngModel"
                  [virtualScroll]="true">
       </ng-select>
   </div>

        <div class="form-group col-6" [hidden]="!CFE(_FilterTypes.IsGuestCall)">
            <label translate>LBL.SOURCE</label>
            <div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Guestcall_Both"
                        name="GuestCall"
                        class="custom-control-input"
                        [value]=""
                        [(ngModel)]="RequestModel.IsGuestCall"
                    />
                    <label
                        class="custom-control-label"
                        for="Guestcall_Both"
                        translate
                        >LBL.ALL</label
                    >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Guestcall_1"
                        name="GuestCall"
                        class="custom-control-input"
                        [value]="true"
                        [(ngModel)]="RequestModel.IsGuestCall"
                    />
                    <label
                        class="custom-control-label"
                        for="Guestcall_1"
                        translate
                        >LBL.GUEST</label
                    >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Guestcall_2"
                        name="GuestCall"
                        class="custom-control-input"
                        [value]="false"
                        [(ngModel)]="RequestModel.IsGuestCall"
                    />
                    <label
                        class="custom-control-label"
                        for="Guestcall_2"
                        translate
                        >LBL.STAFF</label
                    >
                </div>
            </div>
        </div>

        <div
            class="form-group col-6"
            [hidden]="!CFE(_FilterTypes.HasAttachment)"
        >
            <label translate>LBL.ATTACHMENTS</label>
            <div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Attachmentcall_Both"
                        name="AttachmentCall"
                        class="custom-control-input"
                        [value]=""
                        [(ngModel)]="RequestModel.HasAttachment"
                    />
                    <label
                        class="custom-control-label"
                        for="Attachmentcall_Both"
                        translate
                        >LBL.ALL</label
                    >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Attachmentcall_1"
                        name="AttachmentCall"
                        class="custom-control-input"
                        [value]="true"
                        [(ngModel)]="RequestModel.HasAttachment"
                    />
                    <label
                        class="custom-control-label"
                        for="Attachmentcall_1"
                        translate
                        >LBL.YES</label
                    >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Attachmentcall_2"
                        name="AttachmentCall"
                        class="custom-control-input"
                        [value]="false"
                        [(ngModel)]="RequestModel.HasAttachment"
                    />
                    <label
                        class="custom-control-label"
                        for="Attachmentcall_2"
                        translate
                        >LBL.NO</label
                    >
                </div>
            </div>
        </div>

        <div
            class="form-group col-6"
            [hidden]="!CFE(_FilterTypes.HasEscalation)"
        >
            <label translate>LBL.LBL_ESCALATED</label>
            <div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Escalationcall_Both"
                        name="EscalationCall"
                        class="custom-control-input"
                        [value]=""
                        [(ngModel)]="RequestModel.HasEscalation"
                    />
                    <label
                        class="custom-control-label"
                        for="Escalationcall_Both"
                        translate
                        >LBL.ALL</label
                    >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Escalationcall_1"
                        name="EscalationCall"
                        class="custom-control-input"
                        [value]="true"
                        [(ngModel)]="RequestModel.HasEscalation"
                    />
                    <label
                        class="custom-control-label"
                        for="Escalationcall_1"
                        translate
                        >LBL.YES</label
                    >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Escalationcall_2"
                        name="EscalationCall"
                        class="custom-control-input"
                        [value]="false"
                        [(ngModel)]="RequestModel.HasEscalation"
                    />
                    <label
                        class="custom-control-label"
                        for="Escalationcall_2"
                        translate
                        >LBL.NO</label
                    >
                </div>
            </div>
        </div>

        <div
            class="form-group col-6"
            [hidden]="!CFE(_FilterTypes.IsKMTCategory)"
            *ngIf=" masterService.CheckActiveLicence_Module(masterService.ActivePropertyID, 'KMT_CORE')"
        >
            <label translate>LBL.LBL_IS_FROM_MAINTENANCE</label>
            <div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Kmtcall_Both"
                        name="KMTCall"
                        class="custom-control-input"
                        [value]=""
                        [(ngModel)]="RequestModel.IsKmt"
                    />
                    <label
                        class="custom-control-label"
                        for="Kmtcall_Both"
                        translate
                        >LBL.ALL</label
                    >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Kmtcall_1"
                        name="KMTCall"
                        class="custom-control-input"
                        [value]="true"
                        [(ngModel)]="RequestModel.IsKmt"
                    />
                    <label
                        class="custom-control-label"
                        for="Kmtcall_1"
                        translate
                        >LBL.LBL_INCLUDE_ONLY_MAINTENANCE</label
                    >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Kmtcall_2"
                        name="KMTCall"
                        class="custom-control-input"
                        [value]="false"
                        [(ngModel)]="RequestModel.IsKmt"
                    />
                    <label
                        class="custom-control-label"
                        for="Kmtcall_2"
                        translate
                        >LBL.LBL_EXCLUDE_MAINTENANCE</label
                    >
                </div>
            </div>
        </div>

        <div class="form-group col-6" [hidden]="!CFE(_FilterTypes.HasJobs)">
            <label translate>LBL.JOBS</label>
            <div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Jobscall_Both"
                        name="JobsCall"
                        class="custom-control-input"
                        [value]=""
                        [(ngModel)]="RequestModel.HasCallRegistered"
                    />
                    <label
                        class="custom-control-label"
                        for="Jobscall_Both"
                        translate
                        >LBL.ALL</label
                    >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Jobscall_1"
                        name="JobsCall"
                        class="custom-control-input"
                        [value]="true"
                        [(ngModel)]="RequestModel.HasCallRegistered"
                    />
                    <label
                        class="custom-control-label"
                        for="Jobscall_1"
                        translate
                        >LBL.YES</label
                    >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Jobscall_2"
                        name="JobsCall"
                        class="custom-control-input"
                        [value]="false"
                        [(ngModel)]="RequestModel.HasCallRegistered"
                    />
                    <label
                        class="custom-control-label"
                        for="Jobscall_2"
                        translate
                        >LBL.NO</label
                    >
                </div>
            </div>
        </div>

        <div
            class="form-group col-6"
            [hidden]="!CFE(_FilterTypes.HasMembership)"
        >
            <label translate>LBL.MEMBERSHIP</label>
            <div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Membershipcall_Both"
                        name="MembershipCall"
                        class="custom-control-input"
                        [value]=""
                        [(ngModel)]="RequestModel.HasGuestMembership"
                    />
                    <label
                        class="custom-control-label"
                        for="Membershipcall_Both"
                        translate
                        >LBL.ALL</label
                    >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Membershipcall_1"
                        name="MembershipCall"
                        class="custom-control-input"
                        [value]="true"
                        [(ngModel)]="RequestModel.HasGuestMembership"
                    />
                    <label
                        class="custom-control-label"
                        for="Membershipcall_1"
                        translate
                        >LBL.YES</label
                    >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="Membershipcall_2"
                        name="MembershipCall"
                        class="custom-control-input"
                        [value]="false"
                        [(ngModel)]="RequestModel.HasGuestMembership"
                    />
                    <label
                        class="custom-control-label"
                        for="Membershipcall_2"
                        translate
                        >LBL.NO</label
                    >
                </div>
            </div>
   </div>

        <div
            class="form-group col-6"
            [hidden]="!CFE(_FilterTypes.StaffsInvolved)"
        >
            <label translate>LBL.STAFF_INVOLVED</label>
            <ng-select
                [items]="lstInvolvedStaffs"
                bindLabel="Name"
                [multiple]="true"
                [closeOnSelect]="false"
                bindValue="Id"
                placeholder="{{'PH.PH_STAFF' | translate}}"
                name="StaffsInvolved"
                [(ngModel)]="RequestModel.StaffsInvolved"
                #cmbInvolvedStaffs="ngModel"
                [virtualScroll]="true"
            >
            </ng-select>
        </div>

        <div
            class="form-group col-6"
            [hidden]="!CFE(_FilterTypes.HasInvestigation)"
        >
            <label translate>LBL.INVESTIGATION</label>
            <div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="HasInvestigation_Yes"
                        name="HasInvestigation"
                        class="custom-control-input"
                        [value]="true"
                        [(ngModel)]="RequestModel.HasInvestigation"
                    />
                    <label
                        class="custom-control-label"
                        for="HasInvestigation_Yes"
                        translate
                        >LBL.YES</label
                    >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="HasInvestigation_No"
                        name="HasInvestigation"
                        class="custom-control-input"
                        [value]="false"
                        [(ngModel)]="RequestModel.HasInvestigation"
                    />
                    <label
                        class="custom-control-label"
                        for="HasInvestigation_No"
                        translate
                        >LBL.NO</label
                    >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="HasInvestigation_Ignore"
                        name="HasInvestigation"
                        class="custom-control-input"
                        [value]="null"
                        [(ngModel)]="RequestModel.HasInvestigation"
                    />
                    <label
                        class="custom-control-label"
                        for="HasInvestigation_Ignore"
                        translate
                        >LBL.IGNORE</label
                    >
                </div>
            </div>
        </div>

        <div class="form-group col-6" [hidden]="!CFE(_FilterTypes.HasRecovery)">
            <label translate>LBL.RECOVERY</label>
            <div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="HasRecovery_Yes"
                        name="HasRecovery"
                        class="custom-control-input"
                        [value]="true"
                        [(ngModel)]="RequestModel.HasRecovery"
                    />
                    <label
                        class="custom-control-label"
                        for="HasRecovery_Yes"
                        translate
                        >LBL.YES</label
                    >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="HasRecovery_No"
                        name="HasRecovery"
                        class="custom-control-input"
                        [value]="false"
                        [(ngModel)]="RequestModel.HasRecovery"
                    />
                    <label
                        class="custom-control-label"
                        for="HasRecovery_No"
                        translate
                        >LBL.NO</label
                    >
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input
                        type="radio"
                        id="HasRecovery_Ignore"
                        name="HasRecovery"
                        class="custom-control-input"
                        [value]="null"
                        [(ngModel)]="RequestModel.HasRecovery"
                    />
                    <label
                        class="custom-control-label"
                        for="HasRecovery_Ignore"
                        translate
                        >LBL.IGNORE</label
                    >
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button
            type="submit"
            class="btn btn-primary"
            (click)="onFilterApply()"
            translate
        >
            BTN.BTN_APPLY
        </button>
        <button
            class="btn btn-secondary"
            aria-label="Close"
            (click)="onClose()"
            type="button"
            translate
        >
            BTN.BTN_CANCEL
        </button>
    </div>
</div>
